import { CurrentReservation } from '@gyym/sdk'
import { Badge, Empty, Swiper, SwiperProps, Typography } from '@gyym/ui'
import { Facility } from '@gyym/ui/icons'

import { dayjs } from '@/lib/dayjs'

import { DateText, Inner, ReservedProgramsSwiperContainer } from './styles'

export interface ReservedProgramsSwiperProps {
  currentReservations: CurrentReservation[]
}

const swiperOptions: Partial<SwiperProps> = {
  slidesPerView: 3,
  spaceBetween: 16,
  breakpoints: {
    1800: {
      slidesPerView: 5,
      spaceBetween: 16,
      slidesPerGroup: 2,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 16,
      slidesPerGroup: 2,
    },
    960: {
      slidesPerView: 3,
      spaceBetween: 16,
      slidesPerGroup: 2,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 16,
      slidesPerGroup: 2,
    },
    0: {
      slidesPerView: 1.1,
      spaceBetween: 8,
      slidesPerGroup: 1,
    },
  },
}

export const ReservedProgramsSwiper = ({
  currentReservations,
}: ReservedProgramsSwiperProps) => {
  return (
    <ReservedProgramsSwiperContainer>
      <Inner>
        <div className="flex items-center">
          <Typography variant="subhead2">予約中のプログラム</Typography>
        </div>

        <div className="mt-3 h-[90px]">
          <Swiper
            {...swiperOptions}
            id="ReservedProgramsSwiper"
            slides={
              currentReservations.length === 0
                ? [
                    // 同時予約上限の撤廃により残枠/空き枠プレースホルダは廃止。
                    // 0件時は空状態を1スライド表示（カード幅に合わせるためスワイパー内に置く）
                    <Empty
                      key="empty"
                      textPosition="bottom"
                      backgroundImg="/assets/images/empty-glove.png"
                      height={90}
                    >
                      予約中のプログラムはありません。
                    </Empty>,
                  ]
                : currentReservations.map((slide, i) => (
                    <div key={i} className="rounded-md bg-white px-4 py-2">
                      <div className="flex items-center">
                        <Facility minWidth={24} gradient />
                        <div className="ml-2 truncate">
                          <Typography variant="body2">
                            {slide.facility.name}
                          </Typography>
                        </div>
                      </div>

                      <div className="mt-1 flex items-center">
                        <DateText>
                          <Typography variant="subhead2">
                            {dayjs(slide.timetable.startAt).format(
                              'M月D日 H:mm',
                            )}
                            〜
                          </Typography>
                        </DateText>

                        {slide.program.activities.length && (
                          <div className="ml-3 truncate">
                            <Badge>{slide.program.activities[0]?.name}</Badge>
                          </div>
                        )}
                      </div>

                      <div className="flex items-center">
                        <div className="truncate">
                          <Typography variant="body2">
                            {slide.program.name}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  ))
            }
          />
        </div>
      </Inner>
    </ReservedProgramsSwiperContainer>
  )
}
